"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.moneraTheme = exports.moneraBreakpoints = exports.actionButtonBorders = exports.transactionalButtonBorders = exports.inputButtonBorders = exports.moneraBuyBoxButtonBorderAttributes = exports.moneraBuyBoxBorderAttributes = exports.moneraDesktopTypography = exports.buttonTypePalette = exports.moneraFontPalette = void 0;
const color_1 = require("../styles/rio/color");
const shape_1 = require("../styles/rio/shape");
const spacing_1 = require("../styles/rio/spacing");
const typography_1 = require("../styles/rio/typography");
exports.moneraFontPalette = {
    price: '#B12704',
    productHeader: '#CC6600'
};
exports.buttonTypePalette = {
    buyNow: color_1.rioBuyNowButtonColors,
    primary: color_1.rioPrimaryButtonColors
};
exports.moneraDesktopTypography = {
    button: Object.assign(Object.assign({}, typography_1.commonFontAttributes), { fontSize: '13px', lineHeight: '29px', padding: '0 10px 0 11px' })
};
exports.moneraBuyBoxBorderAttributes = {
    border: `1px ${color_1.rioBoxColors.boxBorder} solid`,
    borderRadius: shape_1.rioDesktopBorderRadius.actions
};
exports.moneraBuyBoxButtonBorderAttributes = {
    border: '1px solid',
    borderColor: color_1.rioBuyNowButtonColors.border,
    borderRadius: shape_1.rioDesktopBorderRadius.transactional
};
exports.inputButtonBorders = {
    border: '1px solid',
    borderRadius: '4px'
};
exports.transactionalButtonBorders = {
    border: '1px solid',
    borderRadius: '19px'
};
exports.actionButtonBorders = {
    border: '1px solid',
    borderRadius: '8px'
};
exports.moneraBreakpoints = {
    xs: '420px',
    sm: '600px',
    md: '960px',
    lg: '1280px',
    xl: '1920px'
};
exports.moneraTheme = {
    palettes: {
        font: Object.assign(Object.assign({}, exports.moneraFontPalette), color_1.rioTextColors),
        alert: color_1.rioAlertColors,
        button: exports.buttonTypePalette
    },
    typography: Object.assign(Object.assign({}, typography_1.rioDesktopFonts), exports.moneraDesktopTypography),
    spacings: spacing_1.rioDesktopSpacings,
    borders: {
        inputButton: exports.inputButtonBorders,
        transactionalButton: exports.transactionalButtonBorders,
        actionButton: exports.actionButtonBorders,
        buyBox: exports.moneraBuyBoxBorderAttributes,
        buyBoxButton: exports.moneraBuyBoxButtonBorderAttributes
    },
    breakpoints: exports.moneraBreakpoints
};
